import lock from "../../assets/img/lock.svg";

const SecurityInfo = ({ darkMode }) => (
  <div className="d-flex justify-content-center align-items-start mx-2">
    <img alt="lock" src={lock} className={darkMode ? "lock-bg mx-3" : "mx-3"} />
    <h6 className="fs--16 fw--400 mb-0 text-muted">
      We protect your payment information using encryption to provide bank-level
      security.
    </h6>
  </div>
);

export default SecurityInfo;
